import { useShortcut } from '@nsftx/seven-nxg-retail-vue-sdk'
import { useWidgetsStore } from '@/stores/widgets/widgetsStore'

export const useWidgetShortcuts = () => {
  const { toggleShortcuts, toggleLatestBetslips, toggleCalculator } = useWidgetsStore()

  useShortcut('TOGGLE_SHORTCUTS', toggleShortcuts)
  useShortcut('TOGGLE_LATEST_BETSLIPS', toggleLatestBetslips)
  useShortcut('TOGGLE_CALCULATOR', toggleCalculator)
}
